import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock, normalizeStyle as _normalizeStyle } from "vue";
import _imports_0 from '../../../img/powershield-logo-lg-white.png';
import _imports_1 from '../../../img/powershield-logo-square-white.png';
const _hoisted_1 = {
    key: 0,
    class: "clearfix left_col scroll-view"
};
const _hoisted_2 = { class: "navbar nav_title" };
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("img", {
    class: "large-logo",
    src: _imports_0,
    width: "187"
}, null, -1 /* HOISTED */);
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("img", {
    class: "small-logo",
    src: _imports_1,
    width: "48"
}, null, -1 /* HOISTED */);
const _hoisted_5 = {
    key: 0,
    class: "production-version"
};
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("div", { class: "clearfix" }, null, -1 /* HOISTED */);
const _hoisted_7 = {
    id: "sidebar-menu",
    class: "main_menu main-menu-side no-print"
};
const _hoisted_8 = { class: "menu_section clearfix" };
const _hoisted_9 = { class: "nav side-menu top0" };
const _hoisted_10 = ["onClick"];
const _hoisted_11 = {
    key: 1,
    class: "sidebar-footer hidden-sm"
};
const _hoisted_12 = { class: "clearfix sidebar-footer-version" };
const _hoisted_13 = {
    key: 0,
    class: "clearfix"
};
const _hoisted_14 = { class: "text-white hidden-small" };
const _hoisted_15 = { class: "hidden-small" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_router_link = _resolveComponent("router-link");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        (_ctx.loggedIn)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createVNode(_component_router_link, {
                        to: { name: 'home' },
                        onClick: _ctx.goHome
                    }, {
                        default: _withCtx(() => [
                            _hoisted_3,
                            _createTextVNode(),
                            _hoisted_4
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["onClick"]),
                    _createTextVNode(),
                    (_ctx.hasProductionVersion)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.appVersion), 1 /* TEXT */))
                        : _createCommentVNode("v-if", true)
                ]),
                _createTextVNode(),
                _hoisted_6,
                _createTextVNode(),
                _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("ul", _hoisted_9, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleLinks, (item) => {
                                return (_openBlock(), _createElementBlock("li", {
                                    class: _normalizeClass({ 'current-page': _ctx.isCurrentPage(item), 'active': item.hasChildren && _ctx.menu == item.routeGroup })
                                }, [
                                    (!item.hasChildren)
                                        ? (_openBlock(), _createBlock(_component_router_link, {
                                            key: 0,
                                            tag: "a",
                                            to: { name: item.route },
                                            onClick: ($event) => (_ctx.toggleLink(item))
                                        }, {
                                            default: _withCtx(() => [
                                                (item.icon)
                                                    ? (_openBlock(), _createElementBlock("i", {
                                                        key: 0,
                                                        class: _normalizeClass(['fa', 'fa-fw', item.icon])
                                                    }, null, 2 /* CLASS */))
                                                    : _createCommentVNode("v-if", true),
                                                _createTextVNode(" " + _toDisplayString(item.text), 1 /* TEXT */)
                                            ]),
                                            _: 2 /* DYNAMIC */
                                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to", "onClick"]))
                                        : _createCommentVNode("v-if", true),
                                    _createTextVNode(),
                                    (item.hasChildren)
                                        ? (_openBlock(), _createElementBlock("a", {
                                            key: 1,
                                            onClick: ($event) => (_ctx.toggleMenu(item))
                                        }, [
                                            (item.icon)
                                                ? (_openBlock(), _createElementBlock("i", {
                                                    key: 0,
                                                    class: _normalizeClass(['fa', 'fa-fw', item.icon])
                                                }, null, 2 /* CLASS */))
                                                : _createCommentVNode("v-if", true),
                                            _createTextVNode(" " + _toDisplayString(item.text) + " ", 1 /* TEXT */),
                                            _createElementVNode("span", {
                                                class: _normalizeClass(['fa', 'fa-fw', _ctx.isMenuOpen ? 'fa-chevron-up' : 'fa-chevron-down'])
                                            }, null, 2 /* CLASS */)
                                        ], 8 /* PROPS */, _hoisted_10))
                                        : _createCommentVNode("v-if", true),
                                    _createTextVNode(),
                                    (item.hasChildren && _ctx.menu == item.routeGroup)
                                        ? (_openBlock(), _createElementBlock("ul", {
                                            key: 2,
                                            class: "nav child_menu child-menu-vue",
                                            style: _normalizeStyle({ display: _ctx.isMenuOpen ? 'block' : 'none' })
                                        }, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleChildren(item.children), (child) => {
                                                return (_openBlock(), _createElementBlock("li", {
                                                    class: _normalizeClass({ 'current-page': _ctx.route == child.route })
                                                }, [
                                                    _createVNode(_component_router_link, {
                                                        tag: "a",
                                                        to: { name: child.route },
                                                        onClick: ($event) => (_ctx.toggleLink(child))
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(child.text), 1 /* TEXT */)
                                                        ]),
                                                        _: 2 /* DYNAMIC */
                                                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to", "onClick"])
                                                ], 2 /* CLASS */));
                                            }), 256 /* UNKEYED_FRAGMENT */))
                                        ], 4 /* STYLE */))
                                        : _createCommentVNode("v-if", true)
                                ], 2 /* CLASS */));
                            }), 256 /* UNKEYED_FRAGMENT */))
                        ])
                    ])
                ])
            ]))
            : _createCommentVNode("v-if", true),
        _createTextVNode(),
        (!_ctx.hasProductionVersion)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                    (_ctx.appReleaseDesignation)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                            _createElementVNode("h2", _hoisted_14, _toDisplayString(_ctx.appReleaseDesignation), 1 /* TEXT */)
                        ]))
                        : _createCommentVNode("v-if", true),
                    _createTextVNode(),
                    _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.appVersion), 1 /* TEXT */)
                ])
            ]))
            : _createCommentVNode("v-if", true)
    ], 64 /* STABLE_FRAGMENT */));
}
